import { enums, type Infer, object, string } from "superstruct";

import { BriefBlocksSchema } from "@mpa/platform/brief/schema/index";
import { EmailStatus } from "@mpa/platform/enums/EmailStatus";

import getEnumValues from "../enums/getEnumValues.js";
import { isoDate } from "../scalar_types/isoDate.js";

export const RecipientSchema = object({
    partyAttributeId: string(),
    label: string(),
});

export const EmailListItemSchema = object({
    id: string(),
    subject: string(),
    recipientName: string(),
    recipientEmail: string(),
    status: enums(getEnumValues(EmailStatus)),
    statusAt: isoDate,
});

export const EmailDetailSchema = object({
    id: string(),
    subject: string(),
    recipientName: string(),
    recipientEmail: string(),
    status: enums(getEnumValues(EmailStatus)),
    statusAt: isoDate,
    brief: BriefBlocksSchema,
});

export const SendEmailSchema = object({
    partyAttributeId: string(),
    subject: string(),
    blocks: BriefBlocksSchema,
});

export type EmailListItem = Infer<typeof EmailListItemSchema>;
export type EmailDetail = Infer<typeof EmailDetailSchema>;
export type Recipient = Infer<typeof RecipientSchema>;
export type SendEmail = Infer<typeof SendEmailSchema>;
